import React, { useEffect, useState } from "react";
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { PageCicContainer, MainTitle, PartnerContent, Content, SideImage, MainLogo, Title, Text, TextInput, TextLabel, AdviseBlock, Advise, Photo, ConfirmButton, CheckboxWrapper, CheckboxContainer } from './styled';
import { ProjectListWrapper } from '../page-project-list/styled';
import { useSelector } from 'react-redux';
import { projectSelector, selectedProjectSelector, userSelector, isCicSubmittedSelector } from '../../selectors';
import aHighRes from '../../static/cicillu.jpeg';
import logo from '../../static/cic.jpeg';
const PageCic = () => {
  const [isAccepted, setIsAccepted] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [selectedDays, setSelectedDays] = useState([]);
  const [selectedHours, setSelectedHours] = useState([]);
  const history = useHistory();

  // we don't want the user to go directly to this page. In case of change, data from users & projects must be load first.
  if (history.action === 'POP') {
    history.push('/');
    return null;
  }
  const isCicSubmitted = useSelector(isCicSubmittedSelector);
  const availableDays = ["Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"];
  const selectedProject = useSelector(selectedProjectSelector);
  const {
    profile
  } = useSelector(userSelector);
  const {
    workTypesIds
  } = selectedProject || {};
  const {
    workTypes
  } = useSelector(projectSelector);
  const projectWorkTypes = Object.values(workTypes).filter(wt => workTypesIds.includes(wt.id)).map(w => w = w.tunnelCode);
  const {
    lastName,
    firstName,
    phoneNumber
  } = profile;
  const {
    address
  } = selectedProject;
  const {
    dealId
  } = selectedProject.dealAssociation;
  const handleChange = (value, stateUpdater) => {
    stateUpdater(prevState => {
      const isSelected = prevState.includes(value);
      if (isSelected) {
        return prevState.filter(item => item !== value);
      } else {
        return [...prevState, value];
      }
    });
  };
  const sendInfo = () => {
    const dataForCic = {
      dealId,
      projectWorkTypes,
      address,
      firstName,
      lastName,
      phoneNumber,
      isAccepted,
      selectedDays,
      selectedHours
    };
    axios.post(window.processRuntime.env?.MAKE_CIC_SCENARIO, dataForCic).then(response => {
      setIsSubmitted(true);
      console.log(response);
    }, error => {
      console.log(error);
    });
  };
  return /*#__PURE__*/React.createElement(ProjectListWrapper, null, /*#__PURE__*/React.createElement(PageCicContainer, null, /*#__PURE__*/React.createElement(MainTitle, null, "Banques"), /*#__PURE__*/React.createElement(PartnerContent, null, /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(MainLogo, {
    src: logo,
    alt: "Cic Logo"
  }), /*#__PURE__*/React.createElement(Title, null, "Pr\xE9sentation de notre partenaire CIC Nord-Ouest"), /*#__PURE__*/React.createElement(Text, null, "Nous vous proposons ", /*#__PURE__*/React.createElement("span", null, "un rendez-vous personnalis\xE9 de 20 mn"), " avec un conseiller du CIC Nord-Ouest afin de trouver la meilleure solution pour vous accompagner dans votre projet travaux."), /*#__PURE__*/React.createElement(Text, null, "Je choisis mes pr\xE9f\xE9rences de contact :"), /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement(CheckboxContainer, null, availableDays.map((el, index) => /*#__PURE__*/React.createElement(CheckboxWrapper, {
    key: index,
    isFirst: index === 0
  }, /*#__PURE__*/React.createElement(TextInput, {
    type: "checkbox",
    onChange: () => handleChange(el, setSelectedDays),
    checked: selectedDays.includes(el)
  }), /*#__PURE__*/React.createElement(TextLabel, null, el, el === "Samedi" && ` *`)))), /*#__PURE__*/React.createElement(CheckboxContainer, {
    lowMargin: true
  }, /*#__PURE__*/React.createElement(CheckboxWrapper, {
    isFirst: true
  }, /*#__PURE__*/React.createElement(TextInput, {
    type: "checkbox",
    onChange: () => handleChange('10-12h', setSelectedHours),
    checked: selectedHours.includes('10-12h')
  }), /*#__PURE__*/React.createElement(TextLabel, null, "10-12h")), /*#__PURE__*/React.createElement(CheckboxWrapper, null, /*#__PURE__*/React.createElement(TextInput, {
    type: "checkbox",
    onChange: () => handleChange('14-16h', setSelectedHours),
    checked: selectedHours.includes('14-16h')
  }), /*#__PURE__*/React.createElement(TextLabel, null, "14-16h")))), /*#__PURE__*/React.createElement(Text, null, "* Le samedi uniquement 10-12h"), /*#__PURE__*/React.createElement(AdviseBlock, null, /*#__PURE__*/React.createElement(Advise, null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    onChange: e => setIsAccepted(e.target.checked),
    checked: isCicSubmitted ? true : isAccepted
  }), "En cochant cette case, j\u2019accepte que mes coordonn\xE9es et les informations de mon projet soient transmises au CIC Nord Ouest et uniquement au CIC Nord Ouest de mani\xE8re s\xE9curis\xE9e. J\u2019accepte \xE9galement que le CIC Nord Ouest prenne contact avec moi par t\xE9l\xE9phone et /ou par email.  Cette mise en relation est gratuite.")), /*#__PURE__*/React.createElement(ConfirmButton, {
    disabled: !isAccepted || isCicSubmitted || isSubmitted || selectedDays.length === 0 || selectedHours.length === 0,
    onClick: () => sendInfo()
  }, isSubmitted || isCicSubmitted ? 'Demande envoyée' : "Envoyer ma demande")), /*#__PURE__*/React.createElement(SideImage, null, /*#__PURE__*/React.createElement(Photo, {
    src: aHighRes,
    alt: ""
  })))));
};
export default PageCic;